//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  const curalate = angular.module('curalate');

  curalate.directive('inlineWarning', ['$sce', function($sce) {
    return {
      restrict: 'E',
      scope: {
        id: '@',
        title: '@',
        content: '@',
        titleHtml: '@?',
      },
      template: '<div class="inline-warning" id="{{::id}}">' +
                            '<div class="inline-warning-image"><i class="fa fa-exclamation-circle"></i></div>' +
                            '<div class="inline-warning-message">' +
                                '<div class="inline-warning-header" ng-if="::!titleHtml">{{::title}}</div>' +
                                '<div class="inline-warning-header" ng-bind-html="::trustedTitleHtml" ng-if="::!!titleHtml"></div>' +
                                '<div class="inline-warning-content">{{::content}}</div>' +
                            '</div>' +
                        '</div>',
      link(scope) {
        if (scope.titleHtml) {
          scope.trustedTitleHtml = $sce.trustAsHtml(scope.titleHtml);
        }
      },
    };
  }]);
})();
